import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TrialInsightsLegendOptions } from '../../models/trial-insights-legend.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
  selector: 'aux-trial-insights-legend',
  styleUrls: ['../../trial-insights.component.scss'],
  templateUrl: './trial-insights-legend.component.html',
})
export class TrialInsightsLegendComponent {
  @Input() options: TrialInsightsLegendOptions = {
    centered: false,
    color: '',
    compact: false,
    data: [],
    divider: false,
  };
}
